<template>
    <div class="countdown" v-if="hasDuration()">
        <span class="number" v-if="hasDuration('years')">{{ years }}</span> <span v-if="hasDuration('years')">Jahre</span>
        <span class="number" v-if="hasDuration('months')">{{ months }}</span> <span v-if="hasDuration('months')">Monate</span>
        <span class="number" v-if="hasDuration('days')">{{ days }}</span> <span v-if="hasDuration('days')">Tage</span>
        <span class="number" v-if="hasDuration('hours')">{{ hours }}</span> <span v-if="hasDuration('hours')">Stunden</span>
        <span class="number" v-if="hasDuration('minutes')">{{ minutes }}</span> <span v-if="hasDuration('minutes')">Minuten</span>
        <span class="number" v-if="hasDuration('seconds')">{{ seconds }}</span> <span v-if="hasDuration('seconds')">Sekunden</span>
    </div>
    <div class="expired" v-else>
        <span>Der Countdown zum</span>
        <span>{{ dateReadable }}</span>
        <span>ist abgelaufen.</span>
        <pre>{{ splitDateTime }}</pre>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'start',
        data () {
            return {
                years: null,
                months: null,
                days: null,
                hours: null,
                minutes: null,
                seconds: null,
                dateTime: '1998-07-16T19'
            };
        },
        computed: {
            params () {
                return this.$route.params;
            },
            date () {
                let year = parseInt(this.$route.params.year);
                let month = parseInt(this.$route.params.month);
                let day = parseInt(this.$route.params.day);
                let hour = parseInt(this.$route.params.hour);
                let minute = parseInt(this.$route.params.minute);
                let second = parseInt(this.$route.params.second);
                year = (Number.isInteger(year) && year > 0) ? year : 1970;
                month = (Number.isInteger(month) && month > 0) ? month - 1 : 0;
                day = (Number.isInteger(day) && day > 0) ? day : 1;
                hour = (Number.isInteger(hour) && hour > 0) ? hour : 0;
                minute = (Number.isInteger(minute) && minute > 0) ? minute : 0;
                second = (Number.isInteger(second) && second > 0) ? second : 0;
                return moment([year, month, day, hour, minute, second]);
            },
            dateReadable () {
//                return this.date.format('DD.MM.YYYY [um] HH:mm:ss [Uhr]')
                return this.date.locale('de').format('LLLL');
            },
            splitDateTime () {
                return moment(this.dateTime).hours();
            }
        },
        methods: {
            timer () {
                setInterval(() => {
                    const now = moment();
                    let timerDate = this.date.clone();

                    if (moment.duration(timerDate.diff(now)) <= 0) {
                        clearInterval(this.timer);
                    } else {
                        this.years = Math.floor(moment.duration(timerDate.diff(now)).asYears());
                        this.months = Math.floor(moment.duration(timerDate.subtract(this.years, 'years').diff(now)).asMonths());
                        this.days = Math.floor(moment.duration(timerDate.subtract(this.months, 'months').diff(now)).asDays());
                        this.hours = Math.floor(moment.duration(timerDate.subtract(this.days, 'days').diff(now)).asHours());
                        this.minutes = Math.floor(moment.duration(timerDate.subtract(this.hours, 'hours').diff(now)).asMinutes());
                        this.seconds = Math.floor(moment.duration(timerDate.subtract(this.minutes, 'minutes').diff(now)).asSeconds());
                    }
                }, 1000);
            },
            hasDuration (value) {
                const now = moment();
                let timerDate = this.date.clone();
                let dur = moment.duration(timerDate.diff(now));

                switch (value) {
                    case 'years':
                        return dur.asYears() >= 1;
                    case 'months':
                        return dur.asMonths() >= 1;
                    case 'days':
                        return dur.asDays() >= 1;
                    case 'hours':
                        return dur.asHours() >= 1;
                    case 'minutes':
                        return dur.asMinutes() >= 1;
                    case 'seconds':
                        return dur.asSeconds() >= 1;
                    default:
                        return dur > 0;
                }
            }
        },
        created () {
            this.timer();
            console.log(this.splitDateTime);
        }
    };
</script>

<style scoped lang="scss">
    .countdown {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 90vw;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .countdown span {
        box-sizing: border-box;
        width: 50%;
        padding: 0 0.25em;
        @media(min-width: 40em) {
            width: auto;
            padding: 0;
        }
    }

    .countdown span + span {
        @media(min-width: 40em) {
            margin-left: 0.5em;
        }
    }

    .countdown .number {
        text-align: right;
    }

    .expired {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;

        white-space: nowrap;
    }

    .expired span {
        padding: 0 0.5em;

        &:nth-child(2) {
            background-color: black;
            color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// Start.vue?7b131213